<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    {{ block.label }}
    <v-text-field
      :value="form"
      :dense="block.notDense ? false : true"
      type="number"
      inputmode="numeric"
      :label="block.label"
      outlined
      hide-details="auto"
      :class="block.inputClass"
      placeholder="0"
      @input="$emit('update:form', $event)"
    >
      <template #label>
        What about <strong>icon</strong> here? <v-icon style="vertical-align: middle">
          mdi-file-find
        </v-icon>
      </template>
    </v-text-field>
  </v-col>
</template>

<script>
export default {
   name: 'LabelNumberField',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },
}
</script>
